import StickerHandler from './StickerHandler'

export default StickerHandler


// WEBPACK FOOTER //
// ./src/components/sticker/index.jsx